import React from "react";
import { Grid, IconButton, Typography } from "@mui/material";
import CardTheme1 from "../../components/CardTheme1";
import { injectIntl } from "react-intl";
import { StyleHeading, StyleTooltipMessage, StyleTooltipMessage2, StyleTypography } from "../../assets/js/Theme";
import CardTheme2 from "../../components/CardTheme2";
import { ACTIVE_LISTINGS_LABEL, DLD_LABELS } from "../../resources/Mock";
import { commaSeparateFormat } from "../../resources/utils";
import {
  COMPARABLE_STRING_LENGTH_LG,
  COMPARABLE_STRING_LENGTH_XL,
  COMPARABLE_STRING_LENGTH_XXL,
} from "../../resources/Constants";
import SvgIcon from "../../components/SvgIcon";

function Comparables(props) {
  const { intl, comparables, pricePerSqftData, activeListings, addressLength } =
    props;
  return (
    <>
      {comparables?.length ? (
        <>
          <Grid container>
            <Grid item xs={12}>
              <StyleHeading
                color="primary"
                variant="h1"
                gutterBottom
              >
                {intl.formatMessage({
                  id: "COMPARABLES.SOLD_COMPARABLES",
                })}
                <StyleTooltipMessage2

                title={
                  <>
                    <Typography>
                      {intl.formatMessage({
                        id: "EXPLANATION_SOLD_COMPARABLES_TOOL_TIP",
                      })}
                    </Typography>
                  </>
                }
                arrow
              >
                <IconButton className="tooltip--icon">
                  <SvgIcon name="info" />
                </IconButton>
              </StyleTooltipMessage2>
              </StyleHeading>
            </Grid>
            <Grid item xs={12}>
              <StyleTypography color="primary">
                {intl.formatMessage({ id: "EXPLANATION_SOLD_COMPARABLES" })}
              </StyleTypography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={1}
            className={
              addressLength > COMPARABLE_STRING_LENGTH_XXL
                ? "reduce--font--size--xs"
                : addressLength > COMPARABLE_STRING_LENGTH_XL
                ? "reduce--font--size--sm"
                : addressLength > COMPARABLE_STRING_LENGTH_LG
                ? "reduce--font--size--md"
                : null
            }
          >
            {comparables.map((comp, index) => (
              <Grid item key={index} xs={12} md={3} className="result-card-wrapper">
                <CardTheme1
                  data={comp}
                  name="comparables"
                  labels={DLD_LABELS}
                />
              </Grid>
            ))}
          </Grid>
        </>
      ) : null}
      {pricePerSqftData ? (
        <Grid container className="price_per_sqft_model">
          <Grid item xs={12}>
            <StyleHeading
              color="primary"
              align="center"
              variant="h1"
              gutterBottom
            >
              {`${intl.formatMessage({
                id: "GENERAL.AED",
              })} ${commaSeparateFormat(
                pricePerSqftData.indexedValue
              )} ${intl.formatMessage({
                id: "COMPARABLES.PRICE_PER_SQ_FT",
              })}`}
            </StyleHeading>
            <Typography
              color="primary"
              align="center"
              paragraph
              variant="inherit"
              gutterBottom
            >
              {pricePerSqftData.message}
            </Typography>
          </Grid>
        </Grid>
      ) : null}
      {activeListings?.length ? (
        <>
          <Grid container>
            <Grid item xs={12}>
              <StyleHeading
                color="primary"

                variant="h1"
                gutterBottom
              >
                {intl.formatMessage({
                  id: "COMPARABLES.PROPERTY_LISTINGS",
                })}
                <StyleTooltipMessage
                title={
                  <>
                    <Typography>
                      {intl.formatMessage({
                        id: "EXPLANATION_PROPERTY_LISTINGS_TOOL_TIP",
                      })}
                    </Typography>
                  </>
                }
                arrow
              >
                <IconButton className="tooltip--icon">
                  <SvgIcon name="info" />
                </IconButton>
              </StyleTooltipMessage>
              </StyleHeading>
            </Grid>
            <Grid item xs={12}>
              <StyleTypography color="primary" gutterBottom>
                {intl.formatMessage({ id: "EXPLANATION_PROPERTY_LISTINGS" })}
              </StyleTypography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={1}
            className={
              addressLength > COMPARABLE_STRING_LENGTH_XXL
                ? "reduce--font--size--xs"
                : addressLength > COMPARABLE_STRING_LENGTH_XL
                ? "reduce--font--size--sm"
                : addressLength > COMPARABLE_STRING_LENGTH_LG
                ? "reduce--font--size--md"
                : null
            }
          >
            {activeListings.map((comp, index) => (
              <Grid item key={index} xs={12} md={3} className="result-card-wrapper">
                <CardTheme2
                  data={comp}
                  name="active-listings"
                  labels={ACTIVE_LISTINGS_LABEL}
                />
              </Grid>
            ))}
          </Grid>
        </>
      ) : null}
    </>
  );
}

export default injectIntl(Comparables);
